export function roundPaymentPerMonth(price, month) {
  return (Math.ceil((price/month) * 100) / 100);
}
